import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllPartnerRequestsUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllPartnerRequests implements GetAllPartnerRequestsUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(): Promise<GetAllPartnerRequestsUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
